<template>
  <router-view/>
</template>

<style>
body {
  background: #fff;
  margin: 0px;
 
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #444;
  text-align: center
}
h1 {
  font-size: 20px;
  color: #444;
}

h2 {
  font-size: 18px;
  color: #444;
}
</style>
